import {Action} from '@ngrx/store';

export enum ActionTypes {
    // Session
    SessionRestore = '[Session] Restore ▶',

    // Login
    Login = '[Authentication] Login ▶',
    LoginWith2FA = '[Authentication] Login with 2FA ▶',
    LoginWith2FARequired = '[Authentication] Login 2FA required ✖',
    LoginSuccess   = '[Authentication] Login success ✔',
    LoginFailure = '[Authentication] Login failure ✖',
    LoginNoop   = '[Authentication] Login NOOP action (no-action) ✔',

    // Support Login
    SupportLogin = '[Authentication] SupportLogin ▶',

    // Auto-Client Login
    AutoClientLogin = '[Authentication] AutoClientLogin ▶',

    // Support Logout
    SupportLogout = '[Authentication] Support logout ▶',
    SupportLogoutSuccess   = '[Authentication] Support logout success ✔',

    // Logout
    Logout  = '[Authentication] Logout ▶',
    LogoutToClientSelect = '[Authentication] Logout to Client select ▶',
    LogoutSuccess = '[Authentication] Logout success ✔',
    LogoutToClientSelectSuccess = '[Authentication] Logout to Client select success ✔'
}

export class Login implements Action {
    readonly type = ActionTypes.Login;
    constructor(public payload: any) { console.log(ActionTypes.Login, 'payload:', this.payload); }
}

export class LoginWith2FA implements Action {
    readonly type = ActionTypes.LoginWith2FA;
    constructor(public payload: any) { console.log(ActionTypes.LoginWith2FA, 'payload:', this.payload); }
}

export class LoginWith2FARequired implements Action {
    readonly type = ActionTypes.LoginWith2FARequired;
    constructor(public payload: any) { console.log(ActionTypes.LoginWith2FARequired, 'payload:', this.payload); }
}

export class LoginSuccess implements Action {
    readonly type = ActionTypes.LoginSuccess;
    constructor(public payload: any) { console.log(ActionTypes.LoginSuccess, 'payload:', this.payload); }
}

export class LoginNoop implements Action {
    readonly type = ActionTypes.LoginNoop;
    constructor(public payload: any) { console.log(ActionTypes.LoginNoop, 'payload:', this.payload); }
}

export class LoginFailure implements Action {
    readonly type = ActionTypes.LoginFailure;
    constructor(public payload: any) { console.log(ActionTypes.LoginFailure, 'payload:', this.payload); }
}

export class SupportLogin implements Action {
    readonly type = ActionTypes.SupportLogin;
    constructor(public payload: any) { console.log(ActionTypes.SupportLogin, 'payload:', this.payload); }
}

export class AutoClientLogin implements Action {
    readonly type = ActionTypes.AutoClientLogin;
    constructor(public payload: any) { console.log(ActionTypes.AutoClientLogin, 'payload:', this.payload); }
}

export class SessionRestore implements Action {
    readonly type = ActionTypes.SessionRestore;
}

export class Logout implements Action {
    readonly type = ActionTypes.Logout;
}

export class LogoutToClientSelect implements Action {
    readonly type = ActionTypes.LogoutToClientSelect;
}

export class LogoutToClientSelectSuccess implements Action {
    readonly type = ActionTypes.LogoutToClientSelectSuccess;
    constructor(public payload: any) {}
}

export class LogoutSuccess implements Action {
    readonly type = ActionTypes.LogoutSuccess;
    constructor(public payload: any) {}
}

export class SupportLogout implements Action {
    readonly type = ActionTypes.SupportLogout;
}

export class SupportLogoutSuccess implements Action {
    readonly type = ActionTypes.SupportLogoutSuccess;
    constructor(public payload: any) {}
}

export type LoginActions =
    | Login
    | LoginWith2FA
    | LoginWith2FARequired
    | LoginSuccess
    | LoginFailure
    | LoginNoop
    | SupportLogin
    | AutoClientLogin
    | Logout
    | LogoutToClientSelect
    | LogoutSuccess
    | SupportLogout
    | SupportLogoutSuccess
    ;
